import { BedDouble, Bath, MapPin } from "lucide-react";
import { gbp, imgSrc } from "@/lib/api";
import { StatusBadge } from "@/components/site/StatusBadge";
import { EnquireDialog } from "@/components/site/EnquireDialog";

export const PropertyCard = ({ p }) => (
  <article data-testid={`property-card-${p.id}`} className="group bg-white border border-[#E4E1D9] flex flex-col">
    <div className="relative aspect-[4/3] overflow-hidden bg-[#F3F1ED]">
      {p.images?.[0] && (
        <img src={imgSrc(p.images[0])} alt={p.title} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
      )}
      <div className="absolute top-4 left-4 flex gap-2">
        <StatusBadge status={p.status} />
        {p.is_sample && <span className="px-2.5 py-1 bg-[#121417] text-white font-plex text-[11px] uppercase tracking-wider">Sample</span>}
      </div>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <p className="font-plex text-xs text-[#847F77] flex items-center gap-1.5">
        <MapPin className="h-3.5 w-3.5" /> {p.area}{p.postcode_district ? `, ${p.postcode_district}` : ""}
      </p>
      <h3 className="mt-2 font-display text-xl leading-snug">{p.title}</h3>
      <p className="mt-3 font-display text-2xl text-[#9F7E44]" data-testid={`property-price-${p.id}`}>{gbp(p.price)}</p>
      <div className="mt-4 flex flex-wrap gap-4 text-sm text-[#57534E]">
        <span className="inline-flex items-center gap-1.5"><BedDouble className="h-4 w-4" /> {p.bedrooms} bed</span>
        {p.bathrooms != null && <span className="inline-flex items-center gap-1.5"><Bath className="h-4 w-4" /> {p.bathrooms} bath</span>}
        <span>{p.property_type}</span>
        {p.tenure && <span>{p.tenure}</span>}
      </div>
      {p.features?.length > 0 && (
        <ul className="mt-4 flex flex-wrap gap-2">
          {p.features.slice(0, 4).map((f) => (
            <li key={f} className="text-xs px-2 py-1 bg-[#F7F6F2] text-[#57534E]">{f}</li>
          ))}
        </ul>
      )}
      <div className="mt-auto pt-6"><EnquireDialog property={p} /></div>
    </div>
  </article>
);
